import * as React from 'react';

export function Comment({ fill = '#000', width = 25, height = 25, className, id, onClick }: any) {
    return (
        <svg width='1.4vw' height="1.3vw" viewBox="0 0 20 19" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 3a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5.667a1 1 0 0 0-.6.2L1.6 18.8A1 1 0 0 1 0 18V3zm5 0a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2H5zm0 4a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2H5zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2H5z" fill="#FFF" fill-rule="evenodd" />
        </svg>
    );
}
